/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Teacher comments on a code: a line number (a positive integer as a string) to its text.
 * 
 * Line numbers are 1 to 999999. Texts are trimmed and must be 1 to 1000 characters; at most 500 comments. An empty object
 * removes every comment. Only `teacher_comments` is read, so a comment save never changes the
 * code, its name or its type.
 * @export
 * @interface CodeCommentsUpdate
 */
export interface CodeCommentsUpdate {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CodeCommentsUpdate
     */
    teacher_comments: { [key: string]: string; };
}

/**
 * Check if a given object implements the CodeCommentsUpdate interface.
 */
export function instanceOfCodeCommentsUpdate(value: object): value is CodeCommentsUpdate {
    if (!('teacher_comments' in value) || value['teacher_comments'] === undefined) return false;
    return true;
}

export function CodeCommentsUpdateFromJSON(json: any): CodeCommentsUpdate {
    return CodeCommentsUpdateFromJSONTyped(json, false);
}

export function CodeCommentsUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeCommentsUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'teacher_comments': json['teacher_comments'],
    };
}

export function CodeCommentsUpdateToJSON(json: any): CodeCommentsUpdate {
    return CodeCommentsUpdateToJSONTyped(json, false);
}

export function CodeCommentsUpdateToJSONTyped(value?: CodeCommentsUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacher_comments': value['teacher_comments'],
    };
}

